import moment from "moment";
import { getI18n, useTranslation } from "react-i18next";
import { Card, CardContent } from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import { toast } from "../../components/ui/use-toast";
import fetchData from "../../utils/api";
import ComprehensiveRating from "./StarRating";
import { formatReservationFormat } from "../../utils/table-reservation-format";

export default function TableReservationDetails({ cartList, authToken }) {
  const { t } = useTranslation();
  const lang = getI18n().language;

  const handleSubmitRatingAndFeedback = async ({ rating }) => {
    try {
      const response = await fetchData({
        url: "orders/rating",
        method: "POST",
        token: authToken,
        body: { order_id: cartList.id, rating },
      });
      if (response.status_code === 200) {
        toast({
          title: t("rating.toast_title"),
          description: t(response.message),
        });
      } else {
        toast({
          variant: "destructive",
          title: t("rating.toast_title"),
          description: t(response.message),
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Card>
      <CardContent className="text-center w-full space-y-4 ">
        <div>
          <Label>
            {formatReservationFormat({
              reservation: cartList?.contactDetails?.table_reservation,
              language: lang,
            })}
          </Label>
        </div>
        {cartList?.contactDetails?.table_reservation
          ?.hold_table_reservation_time && (
          <div>
            <Label className="font-semibold">
              {t("table_reservation.note").replace(
                "{time}",
                cartList?.contactDetails?.table_reservation
                  ?.hold_table_reservation_time
              )}
            </Label>
          </div>
        )}
      </CardContent>
      {cartList.status === "delivered" && (
        <ComprehensiveRating
          rating={cartList?.rating ?? 0}
          feedback={cartList?.feedback ?? ""}
          menuRating={cartList?.menuRating ?? []}
          orderItems={cartList?.orderDetails ?? []}
          orderingMethod={cartList?.orderingMethod}
          onSubmit={(ratingData) => {
            handleSubmitRatingAndFeedback({ rating: ratingData });

            // Handle the submission of all ratings
            // You can make your API call here
          }}
        />
      )}
    </Card>
  );
}
